import { getState } from '@/config/redux'
import { selectUserLocale } from '@/redux/userConfig/selectors'
import {
  selectPartnerDefaultLanguage,
  selectConfig,
} from '@/redux/partnerConfig/selectors'
import {
  selectUserProfile,
  selectUserUUID,
  selectUserMembershipCode,
  selectUserConsumerNetwork,
} from '@/redux/userProfile/selectors'
import { selectEnvironment, selectVersion } from '@/redux/signup/selectors'

export default () => {
  const state = getState()

  const appLanguage =
    selectUserLocale(state) || selectPartnerDefaultLanguage(state)
  const userId = selectUserProfile(state)?.id
  const userUUID = selectUserUUID(state)
  const appEvironment = selectEnvironment(state)
  const appVersion = selectVersion(state)
  const membershipCode = selectUserMembershipCode(state)
  const consumerNetworkName = selectUserConsumerNetwork(state)?.name
  const promoCode = selectConfig(state).codes.promo

  return {
    app_build: appVersion,
    app_environment: appEvironment,
    app_name: 'babylon web',
    app_language: appLanguage,
    portal: 'monoweb',
    ...(userId ? { patient_id: userId, uuid: userUUID } : {}),
    ...(membershipCode ? { membership_code: membershipCode } : {}),
    ...(promoCode ? { promotion: promoCode } : {}),
    ...(consumerNetworkName ? { consumer_network: consumerNetworkName } : {}),
  }
}
